import { Accordion, AccordionSummary, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Browser = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel7-content"
                id="panel7-header"
            >
                What browser do I need?
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    Dippi operates as a web-based platform, requiring only a modern web browser for
                    access. For optimal performance and user experience, we recommend utilizing the
                    latest versions of the following web browsers:
                </Typography>
                <Styled.UnorderedList>
                    <Styled.ListItem>
                        <Typography variant="body2">
                            Chrome{" "}
                            <Styled.Link
                                href="https://www.google.com/chrome/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                (https://www.google.com/chrome/)
                            </Styled.Link>
                        </Typography>
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Safari" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Opera" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <Typography variant="body2">
                            Microsoft Edge{" "}
                            <Styled.Link
                                href="https://www.microsoft.com/en-us/download/details.aspx?id=48126"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                (https://www.microsoft.com/en-us/download/details.aspx?id=48126)
                            </Styled.Link>
                        </Typography>
                    </Styled.ListItem>
                </Styled.UnorderedList>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Browser;
